import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, CardHeader, CardTitle, Input, Button, Form } from 'reactstrap';
import { connect } from 'react-redux';
import { sendmessage, getnumbers } from '../../../Redux/Actions/Twilio';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import { Link } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css';
import GetCOmpany from '../../../components/GetCompany/getCompany';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '../../../components/footer';
import Label from 'reactstrap/lib/Label';
import {socket} from '../Main/socket'
// Import the twilioErrorDetails.json file
import twilioErrorDetails from './twilioErrorDetails.json';  // Adjust path if needed
import Background from '../../../components/common/Background';
import corner1 from '../../../assets/img/illustrations/corner-1.png';
import corner2 from '../../../assets/img/illustrations/corner-2.png';
import corner3 from '../../../assets/img/illustrations/corner-3.png';

import UserMessage from '../User/messages';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormGroup from 'reactstrap/lib/FormGroup';
const axios = require('axios');

const SendText = ({ sendmessage, getnumbers, numbers }) => {
  const [num, setnum] = useState('');
  const [err, setErr] = useState(false);
  const [body, setbod] = useState('');
  const [bodyerr, setbodyerr] = useState(false);
  const [from, setfrom] = useState('');
  const [search, setSearch] = useState('');
  const [inboundcheck, setinboundcheck] = useState(false);
  const [outboundcheck, setoutboundcheck] = useState(false);
  const history = useHistory();
  // console.log({inbound:inboundcheck})
  // console.log({outbound:outboundcheck})
  const handleInboundChange = () => {
    if (!inboundcheck && !outboundcheck) {
      setinboundcheck(true);
    } else {
      setinboundcheck(!inboundcheck);
      setoutboundcheck(!outboundcheck);
    }
  };
  const handleOutboundChange = () => {
    if (!inboundcheck && !outboundcheck) {
      setoutboundcheck(true);
    } else {
      setoutboundcheck(!outboundcheck);
      setinboundcheck(!inboundcheck);
    }
  };
  useEffect(() => {
    const param = new URLSearchParams(window.location.search);
    const f = param.get('from');

    const g = param.get('to');
    setnum(g);
    setfrom(f);
  }, []);
  useEffect(() => {
    const a = numbers.map(item => {
      if (item.activate) {
        return item.number;
      }
    });

    setfrom(a[0]);
  }, [numbers]);
  useEffect(() => {
    if (from == 'buynumber') {
      {
        history.push('/buynumber');
      }
    }
  }, [from]);
  useEffect(() => {
    const comp = localStorage.getItem('comp');
    if (comp) {
      getnumbers(comp);
    } else {
      getnumbers();
    }
  }, [getnumbers]);
  const bodydata = e => {
    if (e.target.value.length > 1590) {
      setbodyerr(true);
      toast.error('Message Body length cannot be greater than 1590');
    } else {
      setbod(e.target.value);
      setbodyerr(false);
    }
  };

  useEffect(() => {
      // Ensure connection is established first
      socket.on('connect', () => {
        console.log('Socket connected in User Chat message!');
      });
  
      socket.on('undeliveredMessage', async (data) => {
        console.log("exist From Chat=================================", data);
  
        if (data.status === 'undelivered') {
          // Fetch the error details from the JSON file based on the ErrorCode
          const errorCodeNum = Number(data.ErrorCode);
          const error = twilioErrorDetails.find(item => item.code === errorCodeNum);
  
          if (errorCodeNum === 30034) {
  
            // If the ErrorCode is 30034, show a custom message with registration link
            toast.error(
              <div>
                Your recent message could not be delivered because your number {data.from} is not registered under A2P 10DLC. 
                Please complete your registration <a href="https://call.mergeasy.com/hub" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Here</a>.
              </div>
            );
  
          } else {
            // For other error codes, display a generic message
            toast.error(`${error?.message || error?.description || 'Failed to send message!'}`);
          }
        }
      });
  
      // Cleanup on unmount or disconnection
      return () => {
        socket.off('undeliveredMessage'); // Unsubscribe to avoid memory leaks
        socket.off('connect');
      };
    }, []);

  //  var newnum=()=>{numbers&& numbers[0] && numbers[0].hasOwnProperty("number").return(numbers[0])}
  //  console.log("new number is"+newnum)
  const submit = () => {
    if (!from || num === '' || num.length > 13 || from === '') {
      toast.error('Please select company and a from number');
      setErr(true);
    } else {
      setErr(false);
      sendmessage(num, body, from);
      setnum('');
      setbod('');
    }
  };

  async function geoCallerIDNumber(value, code) {
    if (value && code.dialCode) {
      console.log('value.toString().length=', value.toString().length);
      var countryCode = code.dialCode;
      console.log('countryCode=', countryCode);
      var codeLength = code.dialCode.toString().length;
      console.log('codeLength=', codeLength);
      var areaCode = '';
      console.log('value.toString().length=', value.toString().length);
      if (value.toString().length > 7) {
        areaCode = value.toString().substring(codeLength, codeLength + 3);

        const getAreaOrCountryNumberGeoCallerID = await axios({
          method: 'get',
          url:
            process.env.REACT_APP_PORT +
            `/api/me/getAreaOrCountryNumberGeoCallerID?areaCode=${areaCode}&countryCode=${countryCode}`,
          headers: {
            'x-auth-token': localStorage.getItem('token')
          }
        });

        var areaNumber = getAreaOrCountryNumberGeoCallerID.data.data.areaNumber;
        var countryNumber = getAreaOrCountryNumberGeoCallerID.data.data.countryNumber;
        var defaultNumber = getAreaOrCountryNumberGeoCallerID.data.data.defaultNumber;
        var geocallerid = getAreaOrCountryNumberGeoCallerID.data.data.geocallerid;
        if (geocallerid == true && areaNumber != '') {
          console.log('areaNumber=', areaNumber);
          setfrom(areaNumber);
        } else if (geocallerid == true && countryNumber != '') {
          console.log('countryNumber=', countryNumber);
          setfrom(countryNumber);
        } else if (geocallerid == true && defaultNumber != '') {
          console.log('defaultNumber=', defaultNumber);
          setfrom(defaultNumber);
        } else {
          console.log('nothing to do');
        }
      }
    }
  }

  return (
    <>
    
          <Card>
            <Background image={corner2} className="bg-card" />
            <Row>
              <Col sm={{ size: 5 }} style={{ marginLeft: '24px' }}>
                <Label>Select Company</Label>

                <GetCOmpany />
              </Col>

              <Col sm={{ size: 5, offset: 1 }}>
                <Label>From Number</Label>
                {/* <Input
                  style={{ fontSize: '0.95em' }}
                  type="select"
                  id="exampleSelect"
                  onChange={e => setfrom(e.target.value)}
                  name="from"
                >
            
                  {numbers != undefined && numbers && numbers[0] && numbers[0].hasOwnProperty('number') && (
                    <option selected={numbers[0].number} value={numbers[0].number}>
                      {numbers[0].name ? numbers[0].name : numbers[0].number}
                    </option>
                  )}

                  {numbers != undefined &&
                    numbers &&
                    numbers.slice(1).map(item => {
                      if (item.activate) {
                        return (
                          <option key={item._id} value={item.number}>
                            {item.name ? item.name : item.number}
                          </option>
                        );
                      }
                    })}
                  {numbers == '' && <option value="">Select Number</option>}
                  {numbers == '' && <option value="buynumber">Buy Number</option>}
                </Input> */}

                <Input
  style={{ fontSize: '0.95em' }}
  type="select"
  id="exampleSelect"
  onChange={e => setfrom(e.target.value)}
  name="from"
>
  {/* Render active numbers */}
  {numbers &&
    Array.isArray(numbers) &&
    numbers.length > 0 &&
    numbers.map((item, index) => {
      if (item.activate) {
        return (
          <option
            key={item._id || index}
            value={item.number}
            selected={index === 0 && item.activate}
          >
            {item.name ? item.name : item.number}
          </option>
        );
      }
      return null;
    })}

  {/* If no active number found */}
  {numbers &&
    Array.isArray(numbers) &&
    numbers.length > 0 &&
    !numbers.some(num => num.activate) && (
      <option value="buynumber">Buy Number</option>
    )}

  {/* If numbers is an empty string */}
  {numbers === '' && (
    <>
      <option value="">Select Number</option>
      <option value="buynumber">Buy Number</option>
    </>
  )}
</Input>

            
                {numbers != '' && (
                  <small id="emailHelp" class="form-text text-muted">
                    {from && from != null && from != '' && `Message id will be ${from}`}
                  </small>
                )}
              </Col>
            </Row>
          </Card>
       

      <Row className="mt-3">
        <Col lg={12} className="pr-lg-2 mb-3 mb-lg-0">
          <Card>
            <CardBody>
              <Row>
                <Col md="12">
                  <Label>To Number</Label>
                  {/* <PhoneInput onChange={phone => setnum(phone)} value={num} /> */}
                  <PhoneInput
                    onChange={async (value, country, e, formattedValue) => {
                      geoCallerIDNumber(value, country);
                      setnum(value);
                    }}
                    value={num}
                  />
                </Col>
              </Row>
              <br></br>

              <Row>
                <Col md="12">
                  <Label>Text</Label>
                  <Input
                    style={{ fontSize: '0.95em' }}
                    placeholder="Enter a Text"
                    type="textarea"
                    onChange={bodydata}
                    name="body"
                    value={body}
                  />
                  {/* <small id="emailHelp" class="form-text text-muted">
                    Enter your text here
                  </small> */}
                </Col>
              </Row>
              <br></br>

              <Row>
                <Col md="6" xs="5">
                  <Button onClick={submit} disabled={bodyerr} color="primary" size="sm" className="mr-2">
                    Send Message
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* <Row className="mt-3">
        <Col xs={12} className="col-xxl-8 pr-xl-2 mb-3">
          <Card>
            <Background image={corner2} className="bg-card" />
           
            <Row
  style={{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingTop: '1rem',
    paddingBottom: '0.25rem'
  }}
>
  <Col style={{ flex: '1 1 20%', minWidth: '150px' }}>
    <Label>Message logs</Label>
  </Col>

  <Col style={{ flex: '1 1 30%', minWidth: '250px' }}>
    <Form style={{ display: 'flex', justifyContent: 'space-around' }}>
      <FormGroup check>
        <Label check>
          <Input type="radio" name="radio1" onChange={() => handleInboundChange()} /> Inbound
        </Label>
      </FormGroup>
      <FormGroup check>
        <Label check>
          <Input type="radio" name="radio1" onChange={() => handleOutboundChange()} /> Outbound
        </Label>
      </FormGroup>
    </Form>
  </Col>

  <Col style={{ flex: '1 1 25%', minWidth: '200px' }}>
    <div className="search-box" style={{ position: 'relative',width:"90%" ,paddingBottom:'10px' }}>
      <Form>
        <Input
          type="search"
          placeholder="Search..."
          aria-label="Search"
          className="rounded-pill search-input"
          value={search}
          onChange={({ target }) => setSearch(target.value)}
        />
      </Form>
    </div>
  </Col>
</Row>
          </Card>
        </Col>
      </Row> */}

      <Row
  className="mt-3"
  style={{
    width: '100%',
    maxWidth: '100%',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
  }}
>
  <Col
    xs={12}
    className="col-xxl-8 pr-xl-2 mb-3"
    style={{
      width: '100%',
      maxWidth: '100%',
      padding: 0,
      margin: 0,
      flex: '1 1 100%',
      boxSizing: 'border-box',
    }}
  >
    <Card
      style={{
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      }}
    >
      <Background image={corner2} className="bg-card" />

      <Row
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          paddingTop: '1rem',
          paddingBottom: '0.25rem',
          width: '100%',
          maxWidth: '100%',
          margin: 0,
          boxSizing: 'border-box',
        }}
      >
        {/* Label Section */}
        <Col
          style={{
            flex: '1 1 20%',
            minWidth: '150px',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
          }}
        >
          <Label>Message logs</Label>
        </Col>

        {/* Inbound / Outbound Radio Buttons */}
        <Col
          style={{
            flex: '1 1 30%',
            minWidth: '250px',
            width: '100%',
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxSizing: 'border-box',
          }}
        >
          <Form
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
            }}
          >
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="radio1"
                  onChange={() => handleInboundChange()}
                />{' '}
                Inbound
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="radio1"
                  onChange={() => handleOutboundChange()}
                />{' '}
                Outbound
              </Label>
            </FormGroup>
          </Form>
        </Col>

        {/* Search Bar */}
        <Col
          style={{
            flex: '1 1 25%',
            minWidth: '200px',
            width: '100%',
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            boxSizing: 'border-box',
          }}
        >
          <div
            className="search-box"
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '400px',
              paddingBottom: '10px',
              boxSizing: 'border-box',
            }}
          >
            <Form style={{ width: '100%' }}>
              <Input
                type="search"
                placeholder="Search..."
                aria-label="Search"
                className="rounded-pill search-input"
                value={search}
                onChange={({ target }) => setSearch(target.value)}
                style={{
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              />
              {/* <FontAwesomeIcon icon="search" className="position-absolute text-400 search-box-icon" /> */}
            </Form>
          </div>
        </Col>
      </Row>
    </Card>
  </Col>
</Row>


     
          <UserMessage search={search} outboundcheck={outboundcheck} inboundcheck={inboundcheck} />
     
      {/* <Row>
          <Col md="12">
            <Label>To Number</Label>
            <PhoneInput onChange={phone => setnum(phone)} value={num} />
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Label>Text</Label>
            <Input
              style={{ fontSize: '0.95em' }}
              placeholder="Enter a Text"
              type="textarea"
              onChange={bodydata}
              name="body"
              value={body}
            />
            <small id="emailHelp" class="form-text text-muted">
              Enter your text here
            </small>
          </Col>
        </Row>
        <Row className="p-4">
          <Col md="6" xs="5">
            <Button onClick={submit} disabled={bodyerr} color="primary" size="sm" className="mr-2">
              Send Message
            </Button>
          </Col> */}
      {/* <Col md="6" xs="5">
                            <Link className="btn btn-danger" to="/pages/masstexting">Mass Texting</Link>
                        </Col> */}
      {/* </Row> */}
      {/* <Row className="p-4">
                       <Col xs="6">
                        <Footer/>
                       </Col>
                    </Row> */}
    </>
  );
};
SendText.propTypes = {
  sendmessage: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  numbers: state.Twilio.numbers
});
export default connect(
  mapStateToProps,
  { sendmessage, getnumbers }
)(SendText);
